import { API } from '@utils/axios'

class AuthAPI {
  prefix = '/AdminUser'

  login (body: TAuthAPI.Body.Login) {
    return API.post<TAuthDetail.State['informationAuthed']>(`${this.prefix}/Authenticate`, body)
  }

  me (id: string) {
    return API.get<TAuthDetail.State['user']>(`${this.prefix}/${id}`)
  }

  forgotPassword (body: TAuthAPI.Body.ForgotPassword) {
    return API.post(`${this.prefix}/ForgotPassword`, body)
  }

  resetPassword (body: TAuthAPI.Body.ResetPassword) {
    return API.post(`${this.prefix}/ResetPassword`, body)
  }

  async createAdmin (data: any) {
    const response = await API.post(`${this.prefix}/Register`, data)
    return response.data
  }
}

export const authApi = new AuthAPI()
